import { TFuncKey } from 'react-i18next'

import { ValidationType } from '@auth-portal/types'

export const passwordValidations: { [key: string]: TFuncKey } = {
  Min6Characters: 'form.passwordValidation.min6Characters',
  Min1number: 'form.passwordValidation.min1Number',
  Min1CapitalLetter: 'form.passwordValidation.min1CapitalLetter',
  Min1LowerCaseLetter: 'form.passwordValidation.min1LowerCaseLetter',
  PasswordMatch: 'form.passwordValidation.passwordMatch',
}

export const DefaultPasswordValidationState: ValidationType[] = [
  {
    transKey: passwordValidations.Min6Characters,
    valid: false,
  },
  {
    transKey: passwordValidations.Min1number,
    valid: false,
  },
  {
    transKey: passwordValidations.Min1CapitalLetter,
    valid: false,
  },
  {
    transKey: passwordValidations.Min1LowerCaseLetter,
    valid: false,
  },
  {
    transKey: passwordValidations.PasswordMatch,
    valid: false,
  },
]
